import React, { useEffect } from 'react'
import { setToken } from '../../Services/ApiSauceInstance'

export const useAppFrame = () => {
  useEffect(() => {
    
    if (global.sessionStorage) {
      setToken(global.sessionStorage.getItem('accessToken'))
    }

    return () => {
    }
  }, [])
}
